import SEO from '../components/SEO';
import usePage from '../hooks/usePage';

const DEFAULT_CONTENT = `<h2>Section A: GENERAL INFORMATION</h2>
<table border="1" cellpadding="6" cellspacing="0"><tr><th>S.No</th><th>INFORMATION</th><th>DETAILS</th></tr>
<tr><td>1</td><td>NAME OF THE SCHOOL</td><td>St. Andrews World School Sonipat</td></tr>
<tr><td>2</td><td>AFFILIATION NO.(IF APPLICABLE)</td><td>(pending)</td></tr>
<tr><td>3</td><td>SCHOOL CODE (IF APPLICABLE)</td><td>(pending)</td></tr>
<tr><td>4</td><td>COMPLETE ADDRESS WITH PIN CODE</td><td>Block C, Ansal Sushant City, Sector 61, Kundli, Sonipat, Haryana 131028</td></tr>
<tr><td>5</td><td>PRINCIPAL NAME &amp; QUALIFICATION</td><td>(pending)</td></tr>
<tr><td>6</td><td>SCHOOL EMAIL ID</td><td>info@sawssonipat.com</td></tr>
<tr><td>7</td><td>CONTACT DETAILS</td><td>9266333940, 9266333941</td></tr>
</table>
<h2>Section B: DOCUMENTS AND INFORMATION</h2>
<table border="1" cellpadding="6" cellspacing="0"><tr><th>S.No</th><th>DOCUMENTS/INFORMATION</th><th>UPLOAD DOCUMENTS</th></tr>
<tr><td>1</td><td>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY</td><td>Click Here</td></tr>
<tr><td>2</td><td>COPIES OF SOCIETY/TRUST/COMPANY REGISTRATION RENEWAL CERTIFICATE, AS APPLICABLE</td><td>Click Here</td></tr>
<tr><td>3</td><td>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE BY THE STATE GOVT/UT</td><td>Click Here</td></tr>
<tr><td>4</td><td>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND ITS RENEWAL IF APPLICABLE</td><td>Click Here</td></tr>
<tr><td>5</td><td>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE</td><td>Click Here</td></tr>
<tr><td>6</td><td>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY</td><td>Click Here</td></tr>
<tr><td>7</td><td>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION</td><td>Click Here</td></tr>
<tr><td>8</td><td>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</td><td>Click Here</td></tr>
</table>
<h2>Section C: RESULT AND ACADEMICS</h2>
<table border="1" cellpadding="6" cellspacing="0"><tr><th>S.No</th><th>DOCUMENTS/INFORMATION</th><th>UPLOAD DOCUMENTS</th></tr>
<tr><td>1</td><td>FEE STRUCTURE OF THE SCHOOL</td><td>Click Here</td></tr>
<tr><td>2</td><td>ANNUAL ACADEMIC CALENDAR</td><td>Click Here</td></tr>
<tr><td>3</td><td>LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)</td><td>Click Here</td></tr>
<tr><td>4</td><td>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS</td><td>Click Here</td></tr>
<tr><td>5</td><td>LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION</td><td>Click Here</td></tr>
</table>
<h2>Section D: STAFF (TEACHING)</h2>
<table border="1" cellpadding="6" cellspacing="0"><tr><th>S.No</th><th>INFORMATION</th><th>DETAILS</th></tr>
<tr><td>1</td><td>PRINCIPAL</td><td>(pending)</td></tr>
<tr><td>2</td><td>TOTAL NO. OF TEACHERS</td><td>(pending)</td></tr>
<tr><td>3</td><td>TEACHERS SECTION RATIO</td><td>(pending)</td></tr>
<tr><td>4</td><td>DETAILS OF SPECIAL EDUCATOR</td><td>(pending)</td></tr>
<tr><td>5</td><td>DETAILS OF COUNSELLOR AND WELLNESS TEACHER</td><td>(pending)</td></tr>
</table>
<h2>Section E: SCHOOL INFRASTRUCTURE</h2>
<table border="1" cellpadding="6" cellspacing="0"><tr><th>S.No</th><th>INFORMATION</th><th>DETAILS</th></tr>
<tr><td>1</td><td>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</td><td>(pending)</td></tr>
<tr><td>2</td><td>NO. AND SIZE OF THE CLASSROOMS</td><td>(pending)</td></tr>
<tr><td>3</td><td>NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS</td><td>(pending)</td></tr>
<tr><td>4</td><td>INTERNET FACILITY</td><td>(pending)</td></tr>
<tr><td>5</td><td>LIBRARY</td><td>(pending)</td></tr>
<tr><td>6</td><td>PLAYGROUND</td><td>(pending)</td></tr>
<tr><td>7</td><td>BOYS TOILET</td><td>(pending)</td></tr>
<tr><td>8</td><td>GIRLS TOILET</td><td>(pending)</td></tr>
<tr><td>9</td><td>CAFETERIA</td><td>(pending)</td></tr>
<tr><td>10</td><td>INFIRMARY</td><td>(pending)</td></tr>
<tr><td>11</td><td>NO. OF RAMPS</td><td>(pending)</td></tr>
</table>`;

const MandatoryPublicDisclosure = () => {
  const pageData = usePage('mandatory-public-disclosure', { content: DEFAULT_CONTENT });

  const title = 'Mandatory Public Disclosure';

  return (
    <>
      <SEO title={title} description="Mandatory Public Disclosure as per CBSE guidelines for St. Andrews World School, Sonipat." keywords="Mandatory Public Disclosure, CBSE, St. Andrews Sonipat" />

      <section className="page-hero">
        {!pageData.loading && <img src={pageData.bannerImage || '/images/page-banners/why-choose-us.jpg'} alt={title} className="page-hero-img" loading="eager" />}
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner"></div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="card p-7 md:p-10">
            <h1 className="h-section mb-6">{title}</h1>
            <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData.content || DEFAULT_CONTENT }} />
          </div>
        </div>
      </section>
    </>
  );
};

export default MandatoryPublicDisclosure;
